import { render } from "./Sitemap.vue?vue&type=template&id=26e8fac7&ts=true"
import script from "./Sitemap.vue?vue&type=script&lang=ts"
export * from "./Sitemap.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__